import '../home/home.scss'
import '../onboarding/onboarding.scss'
import './kyb.scss'
import {
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  FormControlLabel,
  Paper,
  Tab,
  Typography,
  TextField,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateKybFilters } from '../../features/kyb/kybSlice'
import DatatableKyb from '../../components/common/datatable/DatatableKyb'
import { useNavigate, useParams } from 'react-router-dom'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import DatatableKyc from '../../components/common/datatable/DatatableKyc'
import { updateKycFilters } from '../../features/kybPerson/kybPersonSlice'
import { useTranslation } from 'react-i18next'
import MyDatePicker from '../../components/utilities/MyDatePicker'
import CountrySelector from '../../components/kyb/countrySelector'
import { selectAvailableCountries, setIsLoading } from '../../features/kyb/kybCountrySlice'
import { FilterModal } from '../../components/utilities/FilterModal'
import KybSearch from './components/KybSearch'
import KybExportReport from './components/KybExportReport'
import { useFindUserMasterQuery } from '../../services/guenoApi'
import dayjs from 'dayjs'

const TabByUrl = {
  'all-kybs': 'kyb',
  'all-kycs': 'kyc',
}

const Kyb = () => {
  const { tab } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation(['common', 'messages'])
  const { emailClient } = useSelector((state) => state.login)
  const kybQueryState = useSelector((state) => state.kyb.filters)
  const kycQueryState = useSelector((state) => state.kybPerson.filters)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [toDate, setToDate] = useState(null)
  const [filtersOpen, setFiltersOpen] = useState(false)
  const [selectedTab, setSelectedTab] = useState(TabByUrl[tab] || 'kyb')
  const isKybs = selectedTab === 'kyb'
  const [showMyAssignments, setShowMyAssignments] = useState(
    isKybs ? kybQueryState.showMyAssignments : kycQueryState.showMyAssignments,
  )

  const [status, setStatus] = useState(isKybs ? kybQueryState.status : kycQueryState.status)
  const [selectedDate, setSelectedDate] = useState(isKybs ? kybQueryState.fromDate : kycQueryState.fromDate)
  const [searchType, setSearchType] = useState(isKybs ? kybQueryState.searchType : kycQueryState.searchType)
  const [searchText, setSearchText] = useState(isKybs ? kybQueryState.searchText : kycQueryState.searchText)
  const [nationality, setNationality] = useState(kycQueryState.nationality)
  const [riskLevel, setRiskLevel] = useState(isKybs ? kybQueryState.riskLevel : kycQueryState.riskLevel)
  const [creationOrigin, setCreationOrigin] = useState(kycQueryState.creationOrigin)

  const [cluster, setCluster] = useState(kybQueryState.cluster || '')
  const [site, setSite] = useState(kybQueryState.site || '')
  const [legalRepresentative, setLegalRepresentative] = useState(kybQueryState.legalRepresentative || '')
  const [legalRepresentativeEmail, setLegalRepresentativeEmail] = useState(kybQueryState.legalRepresentativeEmail || '')
  const [legalRepresentativePhone, setLegalRepresentativePhone] = useState(kybQueryState.legalRepresentativePhone || '')
  const [legalRepresentativeDocumentNumber, setLegalRepresentativeDocumentNumber] = useState(
    kybQueryState.legalRepresentativeDocumentNumber || '',
  )
  const [businessSegments, setBusinessSegments] = useState(kybQueryState.businessSegments || '')
  const [clientTypes, setClientTypes] = useState(kybQueryState.clientTypes || '')
  const [products, setProducts] = useState(kybQueryState.products || '')
  const [fantasia, setFantasia] = useState(kybQueryState.fantasia || '')
  const [registrationStatus, setRegistrationStatus] = useState(kybQueryState.registrationStatus || '')
  const [capitalSocial, setCapitalSocial] = useState(kybQueryState.capitalSocial || '')
  const [legalOrganization, setLegalOrganization] = useState(kybQueryState.legalOrganization || '')
  const [size, setSize] = useState(kybQueryState.size || '')
  const [simplesNacional, setSimplesNacional] = useState(kybQueryState.simplesNacional || '')
  const [monthlyQty, setMonthlyQty] = useState(kybQueryState.monthlyQty || '')
  const [lawsuits, setLawsuits] = useState(kybQueryState.lawsuits || '')
  const [tpv, setTpv] = useState(kybQueryState.tpv || '')
  const [monitoredKyb, setMonitoredKyb] = useState(kybQueryState.monitored || '')

  // Estados específicos para KYC
  const [email, setEmail] = useState(kycQueryState.email || '')
  const [dateOfBirth, setDateOfBirth] = useState(kycQueryState.dateOfBirth || '')
  const [monitored, setMonitored] = useState(kycQueryState.monitored || '')
  const [motherName, setMotherName] = useState(kycQueryState.motherName || '')
  const [gender, setGender] = useState(kycQueryState.gender || '')
  const [situacaoImpostoRenda, setSituacaoImpostoRenda] = useState(kycQueryState.situacaoImpostoRenda || '')
  const [rendaPresumida, setRendaPresumida] = useState(kycQueryState.rendaPresumida || '')
  const [cpfRegistrationDate, setCpfRegistrationDate] = useState(kycQueryState.cpfRegistrationDate || '')
  const [phoneNumber, setPhoneNumber] = useState(kycQueryState.phoneNumber || '')
  const [presumedIncome, setPresumedIncome] = useState(kycQueryState.presumedIncome || '')

  // Campos comunes para KYB tipo BUSINESS
  const commonFilterFieldsKyb = [
    { key: 'businessSegments', label: 'common:businessSegment' },
    { key: 'cluster', label: 'common:cluster' },
    { key: 'site', label: 'common:site' },
    { key: 'legalRepresentative', label: 'common:legalRepresentative' },
    { key: 'legalRepresentativeEmail', label: 'common:legalRepresentativeEmail' },
    { key: 'legalRepresentativePhone', label: 'common:legalRepresentativePhone' },
    { key: 'legalRepresentativeDocumentNumber', label: 'common:legalRepresentativeDocumentNumber' },
    { key: 'clientTypes', label: 'common:clientTypes' },
    { key: 'products', label: 'common:products' },
    { key: 'monitored', label: 'common:monitored' },
  ]
  const commonFilterStateKyb = {
    businessSegments,
    cluster,
    site,
    legalRepresentative,
    legalRepresentativeEmail,
    legalRepresentativePhone,
    legalRepresentativeDocumentNumber,
    clientTypes,
    products,
    monitored: monitoredKyb,
  }
  const commonFilterSettersKyb = {
    businessSegments: setBusinessSegments,
    cluster: setCluster,
    site: setSite,
    legalRepresentative: setLegalRepresentative,
    legalRepresentativeEmail: setLegalRepresentativeEmail,
    legalRepresentativePhone: setLegalRepresentativePhone,
    legalRepresentativeDocumentNumber: setLegalRepresentativeDocumentNumber,
    clientTypes: setClientTypes,
    products: setProducts,
    monitored: setMonitoredKyb,
  }

  // Campos comunes para KYC (inicial, puedes ir agregando más luego)
  const commonFilterFieldsKyc = [
    { key: 'nationality', label: 'common:nationality' },
    { key: 'email', label: 'common:email' },
    { key: 'dateOfBirth', label: 'common:dateOfBirth' },
    { key: 'monitored', label: 'common:monitored' },
    { key: 'motherName', label: 'common:motherName' },
    { key: 'gender', label: 'common:gender' },
    { key: 'situacaoImpostoRenda', label: 'common:situacaoImpostoRenda' },
    { key: 'rendaPresumida', label: 'common:rendaPresumida' },
    { key: 'cpfRegistrationDate', label: 'common:cpfRegistrationDate' },
    { key: 'phoneNumber', label: 'common:phoneNumber' },
  ]
  const commonFilterStateKyc = {
    nationality,
    email,
    dateOfBirth,
    monitored,
    motherName,
    gender,
    situacaoImpostoRenda,
    rendaPresumida,
    cpfRegistrationDate,
    phoneNumber,
  }
  const commonFilterSettersKyc = {
    nationality: setNationality,
    email: setEmail,
    dateOfBirth: setDateOfBirth,
    monitored: setMonitored,
    motherName: setMotherName,
    gender: setGender,
    situacaoImpostoRenda: setSituacaoImpostoRenda,
    rendaPresumida: setRendaPresumida,
    cpfRegistrationDate: setCpfRegistrationDate,
    phoneNumber: setPhoneNumber,
    presumedIncome: setPresumedIncome,
  }

  const brazilFilterFields = [
    { key: 'fantasia', label: 'common:fantasyName' },
    { key: 'registrationStatus', label: 'common:registrationStatus' },
    { key: 'capitalSocial', label: 'common:capitalSocial' },
    { key: 'legalOrganization', label: 'common:legalOrganization' },
    { key: 'size', label: 'common:size' },
    { key: 'simplesNacional', label: 'common:simplesNacional' },
    { key: 'monthlyQty', label: 'common:monthlyQty' },
    { key: 'lawsuits', label: 'common:lawsuits' },
    { key: 'tpv', label: 'common:tpv' },
  ]
  const brazilFilterState = {
    fantasia,
    registrationStatus,
    capitalSocial,
    legalOrganization,
    size,
    simplesNacional,
    monthlyQty,
    lawsuits,
    tpv,
  }
  const brazilFilterSetters = {
    fantasia: setFantasia,
    registrationStatus: setRegistrationStatus,
    capitalSocial: setCapitalSocial,
    legalOrganization: setLegalOrganization,
    size: setSize,
    simplesNacional: setSimplesNacional,
    monthlyQty: setMonthlyQty,
    lawsuits: setLawsuits,
    tpv: setTpv,
  }

  const isDirtySearchText = searchText !== (isKybs ? kybQueryState.searchText : kycQueryState.searchText)

  const { availableCountriesLoading } = useSelector((state) => selectAvailableCountries(state, emailClient))

  const useMasterResponse = useFindUserMasterQuery({ emailClient })

  const { currentCountry } = useSelector((state) => state.kybCountry)

  const handleResetButton = () => {
    if (status) setStatus('ALL')
    if (nationality) setNationality('')
    if (selectedDate) setSelectedDate(null)
    if (riskLevel) setRiskLevel('')
    if (creationOrigin) setCreationOrigin('')
    setBusinessSegments('')
    setCluster('')
    setSite('')
    setLegalRepresentative('')
    setLegalRepresentativeEmail('')
    setLegalRepresentativePhone('')
    setLegalRepresentativeDocumentNumber('')
    setClientTypes('')
    setProducts('')
    setFantasia('')
    setRegistrationStatus('')
    setCapitalSocial('')
    setLegalOrganization('')
    setSize('')
    setSimplesNacional('')
    setMonthlyQty('')
    setLawsuits('')
    setTpv('')
    setMonitoredKyb('')
    setEmail('')
    setDateOfBirth('')
    setMonitored('')
    setMotherName('')
    setGender('')
    setSituacaoImpostoRenda('')
    setRendaPresumida('')
    setCpfRegistrationDate('')
    setPhoneNumber('')
    setPage(0)

    const filters = {
      limit: rowsPerPage,
      offset: 0,
      page: 0,
      status: 'ALL',
      fromDate: null,
      toDate: '',
      searchType,
      searchText,
      showMyAssignments,
      riskLevel: '',
      businessSegments: '',
      cluster: '',
      site: '',
      legalRepresentative: '',
      legalRepresentativeEmail: '',
      legalRepresentativePhone: '',
      legalRepresentativeDocumentNumber: '',
      clientTypes: '',
      products: '',
      monitored: '',
      fantasia: '',
      registrationStatus: '',
      capitalSocial: '',
      legalOrganization: '',
      size: '',
      simplesNacional: '',
      monthlyQty: '',
      lawsuits: '',
      tpv: '',
      // Campos específicos de KYC
      email: '',
      dateOfBirth: '',
      motherName: '',
      gender: '',
      situacaoImpostoRenda: '',
      rendaPresumida: '',
      cpfRegistrationDate: '',
      phoneNumber: '',
    }

    setFiltersOpen(false)

    if (isKybs) {
      dispatch(
        updateKybFilters({
          ...filters,
        }),
      )
    } else {
      dispatch(
        updateKycFilters({
          ...filters,
          creationOrigin: '',
          nationality: '',
        }),
      )
    }
  }

  const handleDispatch = (extraFilters = {}) => {
    const selectedStartOfDay = selectedDate ? dayjs(selectedDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null
    const todayEndOfDay = toDate ? dayjs(toDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss') : null
    const filters = {
      limit: rowsPerPage,
      offset: rowsPerPage * page,
      page,
      status,
      ...(selectedDate && { fromDate: selectedStartOfDay }),
      toDate: todayEndOfDay,
      searchType,
      searchText,
      showMyAssignments,
      ...(riskLevel && { riskLevel }),
      ...(creationOrigin && { creationOrigin }),
      ...(businessSegments && { businessSegments }),
      ...(cluster && { cluster }),
      ...(site && { site }),
      ...(legalRepresentative && { legalRepresentative }),
      ...(legalRepresentativeEmail && { legalRepresentativeEmail }),
      ...(legalRepresentativePhone && { legalRepresentativePhone }),
      ...(legalRepresentativeDocumentNumber && { legalRepresentativeDocumentNumber }),
      ...(clientTypes && { clientTypes }),
      ...(products && { products }),
      ...(monitoredKyb && { monitored: monitoredKyb }),
      ...(fantasia && { fantasia }),
      ...(registrationStatus && { registrationStatus }),
      ...(capitalSocial && { capitalSocial }),
      ...(legalOrganization && { legalOrganization }),
      ...(size && { size }),
      ...(simplesNacional && { simplesNacional }),
      ...(monthlyQty && { monthlyQty }),
      ...(lawsuits && { lawsuits }),
      ...(tpv && { tpv }),
      ...(email && { email }),
      ...(dateOfBirth && { dateOfBirth }),
      ...(monitored && { monitored }),
      ...(motherName && { motherName }),
      ...(gender && { gender }),
      ...(situacaoImpostoRenda && { situacaoImpostoRenda }),
      ...(rendaPresumida && { rendaPresumida }),
      ...(cpfRegistrationDate && { cpfRegistrationDate }),
      ...(phoneNumber && { phoneNumber }),
      ...(nationality && { nationality }),
      ...(dateOfBirth && { dateOfBirth }),
      ...(presumedIncome && { presumedIncome }),
      ...extraFilters,
    }

    if (isKybs) {
      dispatch(updateKybFilters({ ...filters }))
    } else {
      dispatch(
        updateKycFilters({
          ...filters,
        }),
      )
    }
    dispatch(setIsLoading(false))
  }

  const handleChangeSelectedTab = (_, newValue) => {
    handleResetButton()
    setSelectedTab(newValue)
    if (newValue === 'kyb') navigate(`/kyb/all-kybs`)
    if (newValue === 'kyc') navigate(`/kyb/all-kycs`)
  }

  useEffect(() => {
    if (currentCountry) {
      handleDispatch()
    }
  }, [rowsPerPage, page, showMyAssignments, currentCountry, riskLevel, creationOrigin])

  useEffect(() => {
    const currentSearchType = isKybs ? kybQueryState.searchType : kycQueryState.searchType
    if (searchType !== currentSearchType) {
      setSearchText('')
    }
  }, [isKybs, kybQueryState.searchType, kycQueryState.searchType, searchType])

  useEffect(() => {
    if (selectedDate) {
      const formattedDate = new Date(selectedDate)
      setToDate(selectedDate ? formattedDate.setDate(formattedDate.getDate()) : null)
    }
  }, [selectedDate])

  useEffect(() => {
    setSearchText(isKybs ? kybQueryState.searchText : kycQueryState.searchText)
    setSearchType(isKybs ? kybQueryState.searchType : kycQueryState.searchType)
    setShowMyAssignments(isKybs ? kybQueryState.showMyAssignments : kycQueryState.showMyAssignments)
    setRiskLevel(isKybs ? kybQueryState.riskLevel : kycQueryState.riskLevel)
  }, [tab])

  if (useMasterResponse.isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box className={`${availableCountriesLoading && 'spinner-transition'} filter`}>
      <Box>
        <Box className="component-title">
          <Typography variant="h2">{t(`messages:kyb.menu.history`)}</Typography>
          <Box sx={{ display: 'flex', textAlign: 'center', justifyContent: 'center', gap: 2 }}>
            {currentCountry === 'BR' && <KybExportReport />}
            <CountrySelector />
          </Box>
        </Box>
      </Box>
      <TabContext value={selectedTab}>
        <Box display="flex" justifyContent="space-between">
          <TabList
            TabIndicatorProps={{
              style: { display: 'none' },
            }}
            sx={{ marginBottom: '1rem' }}
            onChange={handleChangeSelectedTab}
          >
            <Tab
              label={
                <Chip
                  label={t('messages:kyb.tabs.companies')}
                  variant={selectedTab === 'kyb' ? 'sliderSelected' : 'slider'}
                />
              }
              value="kyb"
            />
            <Tab
              label={
                <Chip
                  label={t('messages:kyb.tabs.persons')}
                  variant={selectedTab === 'kyc' ? 'sliderSelected' : 'slider'}
                />
              }
              value="kyc"
            />
          </TabList>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <KybSearch
            viewType={isKybs ? 'kyb' : 'kyc'}
            country={currentCountry}
            handleSearch={handleDispatch}
            searchText={searchText}
            setSearchText={setSearchText}
            searchType={searchType}
            setSearchType={setSearchType}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  inputProps={{ 'aria-label': 'controlled' }}
                  checked={showMyAssignments}
                  onChange={(e) => setShowMyAssignments(e.target.checked)}
                />
              }
              label={isKybs ? 'My KYBs' : 'My KYCs'}
            />
          </Box>
        </Box>

        <Paper elevation={0}>
          <TabPanel value="kyb">
            <DatatableKyb
              setIsLoading={setIsLoading}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setModalOpen={setFiltersOpen}
              documentNumber={searchText}
              creationOnNoRows={
                !showMyAssignments && searchType === 'documentNumber' && !!searchText && !isDirtySearchText
              }
              riskLevel={riskLevel}
              setRiskLevel={setRiskLevel}
              status={status}
              setStatus={setStatus}
              handleDispatch={handleDispatch}
            />
          </TabPanel>

          <TabPanel value="kyc">
            <DatatableKyc
              isLoading={availableCountriesLoading}
              setIsLoading={setIsLoading}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setModalOpen={setFiltersOpen}
              documentNumber={searchText}
              creationOnNoRows={
                !showMyAssignments && searchType === 'documentNumber' && !!searchText && !isDirtySearchText
              }
              riskLevel={riskLevel}
              setRiskLevel={setRiskLevel}
              creationOrigin={creationOrigin}
              setCreationOrigin={setCreationOrigin}
              handleDispatch={handleDispatch}
              status={status}
              setStatus={setStatus}
            />
          </TabPanel>
        </Paper>
      </TabContext>

      <FilterModal
        modalOpen={filtersOpen}
        setModalOpen={setFiltersOpen}
        handleResetButton={handleResetButton}
        setPage={setPage}
        handleDispatch={handleDispatch}
      >
        <Box className="modal-box-filters">
          <Box className="modal-box">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="subtitle3" sx={{ mb: 0.5 }}>{t('common:fromDate')}:</Typography>
              <MyDatePicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} label={t('common:fromDate')} />
              <Typography variant="subtitle3" sx={{ mt: 1, mb: 0.5 }}>{t('common:toDate')}:</Typography>
              <MyDatePicker selectedDate={toDate} setSelectedDate={setToDate} label={t('common:toDate')} />
            </Box>
          </Box>
          {isKybs
            ? commonFilterFieldsKyb.map(({ key, label }) => (
                <Box className="modal-box" key={key}>
                  <Typography variant="subtitle3">{t(label)}:</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={commonFilterStateKyb[key]}
                    onChange={(e) => commonFilterSettersKyb[key](e.target.value)}
                  />
                </Box>
              ))
            : commonFilterFieldsKyc.map(({ key, label }) => (
                <Box className="modal-box" key={key}>
                  <Typography variant="subtitle3">{t(label)}:</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={commonFilterStateKyc[key]}
                    onChange={(e) => commonFilterSettersKyc[key](e.target.value)}
                  />
                </Box>
              ))}
          {isKybs && currentCountry === 'BR' && (
            <>
              {brazilFilterFields.map(({ key, label }) => (
                <Box className="modal-box" key={key}>
                  <Typography variant="subtitle3">{t(label)}:</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={brazilFilterState[key]}
                    onChange={(e) => brazilFilterSetters[key](e.target.value)}
                  />
                </Box>
              ))}
            </>
          )}
        </Box>
      </FilterModal>
    </Box>
  )
}

export default Kyb
